exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section[data-v-a9cc9e62]{margin:0 25px 80px}.section .text[data-v-a9cc9e62]{text-align:left;margin-bottom:20px}.line-link[data-v-a9cc9e62],.section-image[data-v-a9cc9e62]{padding:20px 40px;-webkit-box-sizing:border-box;box-sizing:border-box}.line-link[data-v-a9cc9e62]{display:block}.line-image[data-v-a9cc9e62]{width:100%}.reserve-title[data-v-a9cc9e62]{text-align:left}.counseling[data-v-a9cc9e62]{background:#fff;color:#000;padding:20px;margin-bottom:40px}.brfore-settlement[data-v-a9cc9e62]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a9cc9e62","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Reserve.vue
// module id = PTph
// module chunks = 1